import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { socketFunc } from "../../../../utils/socketUtil";
import Footer from "../../../../containers/Footer";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";

const Spmsports = () => {
  console.log("spmsports", "");
  const { category } = useParams();
  const [lobbyUrl, setLobbyUrl] = useState();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      const socket = socketFunc(localStorage.getItem("token"));
      try {
        const lobbyConfig = {
          config: {
            launchPage: category,
            theme: "slate-theme",
          },
        };
        socket.emit("get:spmsports_lobby", lobbyConfig, (res) => {
          if (typeof res?.data?.lobby === "string") {
            setLobbyUrl(res?.data?.lobby);
          }
        });
      } catch (err) {
        console.error(err);
        return;
      }
    }
  }, [category]);

  return (
    <div>
      <div>
        <HeaderAfterLogin />
      </div>
      <div>
        <iframe
          src={lobbyUrl}
          style={{
            width: "100%",
            height: "100vh",
          }}
        />
      </div>
    </div>
  );
};

export default Spmsports;
